/* ANIMA - take-it-apart product stage v3.0
   Builds the stage, then drives the scroll scrub.

   Writes five numbers onto .an-ex and nothing else:
     --p   overall progress 0->1
     --p1/--p2/--p3  per part, eased, overlapping ranges
     --mx  pointer offset -1->1 (fine pointers only)
   All geometry lives in anima-stage.css as calc() off those.

   WHY JS AND NOT THE SECTION: the stage sits inside
   templates/index.json - 21.7 KB, replaceable only as a whole, no
   patch API. A slip there takes down the homepage. This file's
   blast radius is itself. If it stays, move it into the section.

   CDN URLs are hard-coded. If those images are re-uploaded the URLs
   change and the stage falls back to the original SVG - safe, but
   check here first if the panel ever looks wrong. */
(function () {
  'use strict';

  var BASE = 'https://cdn.shopify.com/s/files/1/1058/1629/3706/files/';
  var PARTS = [
    { k: 'tub',    f: 'Generatedimage4_6c5838f0-cd71-4896-bdd8-9771c8b6a0bc.png', w: 700, c: 'The tub · 500 g',        a: 'Anima micronised creatine monohydrate 500 g tub' },
    { k: 'label',  f: 'anima-supplement-facts-creatine.png',                      w: 700, c: 'The label · printed',    a: 'Anima creatine supplement facts panel' },
    { k: 'powder', f: 'anima-creatine-500g-04-powder-macro.png',                  w: 600, c: 'The powder · 200 mesh', a: 'Micronised 200-mesh creatine powder texture' }
  ];

  var wrap = null;

  function build() {
    var stage = document.querySelector('.an-pn__stage');
    if (!stage || stage.dataset.anEx) return;
    if (!stage.querySelector('svg')) return;   // already rebuilt properly; leave alone
    stage.dataset.anEx = '1';

    var w = document.createElement('div');
    w.className = 'an-ex';
    var scene = document.createElement('div');
    scene.className = 'an-ex__scene';
    w.appendChild(scene);

    PARTS.forEach(function (p) {
      var fig = document.createElement('figure');
      fig.className = 'an-ex__part an-ex__' + p.k;
      var img = document.createElement('img');
      img.src = BASE + p.f + '?width=' + p.w;
      img.alt = p.a;
      img.decoding = 'async';
      var cap = document.createElement('figcaption');
      cap.className = 'an-ex__cap';
      cap.textContent = p.c;
      fig.appendChild(img);
      fig.appendChild(cap);
      scene.appendChild(fig);
    });

    // Swap only once the tub has decoded, so the panel never flashes
    // empty between removing the SVG and painting the render.
    var probe = new Image(), done = false;
    function swap() {
      if (done) return;
      done = true;
      stage.innerHTML = '';
      stage.appendChild(w);
      wrap = w;
      start();
    }
    probe.onload = swap;
    probe.onerror = function () {};   // leave the original SVG in place
    probe.src = BASE + PARTS[0].f + '?width=' + PARTS[0].w;
    setTimeout(swap, 2500);
  }

  // easeOutCubic, and a remap so each part owns a slice of --p
  function ease(t) { t = t < 0 ? 0 : t > 1 ? 1 : t; return 1 - Math.pow(1 - t, 3); }
  function slice(p, a, b) { return ease((p - a) / (b - a)); }

  function start() {
    if (!wrap) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; // CSS pins everything at 1

    var ticking = false;

    function update() {
      ticking = false;
      var r = wrap.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      // 0 when the stage top sits at 88% of the viewport,
      // 1 by the time it has risen to 38%.
      var p = (vh * 0.88 - r.top) / (vh * 0.50);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      var s = wrap.style;
      s.setProperty('--p',  p.toFixed(3));
      s.setProperty('--p1', slice(p, 0.00, 0.55).toFixed(3));
      s.setProperty('--p2', slice(p, 0.15, 0.75).toFixed(3));
      s.setProperty('--p3', slice(p, 0.30, 0.95).toFixed(3));
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    // Pointer parallax, desktop only. Small on purpose - it should
    // read as the object having volume, not as the page wobbling.
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var mTick = false, mx = 0;
      window.addEventListener('mousemove', function (e) {
        mx = (e.clientX / (window.innerWidth || 1)) * 2 - 1;
        if (!mTick) {
          mTick = true;
          requestAnimationFrame(function () {
            mTick = false;
            wrap.style.setProperty('--mx', mx.toFixed(3));
          });
        }
      }, { passive: true });
    }

    // If rAF never runs - background tab, throttled renderer - the
    // CSS defaults already hold every number at 1, so the finished
    // composition is what shows. Nothing here can hide content.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  document.addEventListener('shopify:section:load', build);
})();
